import React from 'react';

export const Verified: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_7225_112016"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7225_112016)">
      <path
        d="M7.16666 18.75L5.58333 16.0833L2.58333 15.4167L2.87499 12.3333L0.833328 10L2.87499 7.66667L2.58333 4.58333L5.58333 3.91667L7.16666 1.25L10 2.45833L12.8333 1.25L14.4167 3.91667L17.4167 4.58333L17.125 7.66667L19.1667 10L17.125 12.3333L17.4167 15.4167L14.4167 16.0833L12.8333 18.75L10 17.5417L7.16666 18.75ZM7.875 16.625L10 15.7083L12.1667 16.625L13.3333 14.625L15.625 14.0833L15.4167 11.75L16.9583 10L15.4167 8.20833L15.625 5.875L13.3333 5.375L12.125 3.375L10 4.29167L7.83333 3.375L6.66666 5.375L4.37499 5.875L4.58333 8.20833L3.04166 10L4.58333 11.75L4.37499 14.125L6.66666 14.625L7.875 16.625ZM9.125 12.9583L13.8333 8.25L12.6667 7.04167L9.125 10.5833L7.33333 8.83333L6.16666 10L9.125 12.9583Z"
        fill="#696EE0"
      />
    </g>
  </svg>
);
